/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Fragment, PureComponent } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';

import '../../css/event210621.css';

// import { ToastContainer, toast } from "react-toastify"; //토스트(toast)
// import moment from "moment";
// import axios from "axios";

class ContentItem5 extends PureComponent {
  state = {
    alram: 0,
  };
  _goContent = (contentSerial) => {
    const { setContentSerial } = this.props;
    setContentSerial(contentSerial);
  };
  UNSAFE_componentWillReceiveProps = (nextProps, nextState) => {
    //console.log(this.props.location.pathname)
    //console.log(nextProps.location)
    return this.props.childProps.reset !== nextProps.childProps.reset;
    //return true;
  };
  componentWillReceiveProps = (nextProps) => {
    ////console.log(nextProps)

    if (this.props.childProps.reset !== nextProps.childProps.reset) {
      this.setState({
        alram: 0,
      });
    }
  };

  _onExpect = async () => {
    const { contentSerial, img, title, alramFlag, _expect, grade } =
      this.props.childProps;

    const a = await _expect(contentSerial, img, title, alramFlag, grade);
    //console.log(a)
    //if(parseInt(a) === 100) {
    this.setState({
      alram: parseInt(a),
    });
    //}
  };
  _onExpectApi = () => {};
  render() {
    const { contentSerial, img, comment, title, reset } = this.props.childProps;
    const { alram } = this.state;
    const { imgUrl } = this.props;

    //onsole.log(reset)
    return (
      <Fragment>
        {reset ? (
          <div className="item">
            <div className="thumb">
              <a
                onClick={() => this._goContent(contentSerial)}
                style={{ cursor: 'pointer' }}
              >
                <img src={img} />
              </a>
            </div>
            <div className="info">
              <p className="date">
                <img
                  src={imgUrl + '/img/event/event220617/ico_live.png'}
                  alt="LIVE"
                />{' '}
                {comment}
              </p>
              <p className="subject">
                <a
                  onClick={() => this._goContent(contentSerial)}
                  style={{ cursor: 'pointer' }}
                >
                  {title}
                </a>
              </p>
            </div>
            <button
              type="button"
              className={alram === 0 ? 'btnAlram' : 'btnAlram active'}
            >
              뽑기선택
            </button>
          </div>
        ) : alram === 0 ? (
          <div className="item">
            <div className="thumb none">
              <img
                src={imgUrl + '/img/event/event220617/list_img.png'}
                className="img_web"
              />
              <img
                src={imgUrl + '/img/event/event220617/m_list_img.png'}
                className="img_m"
              />
            </div>
            <button type="button" className="btnAlram" onClick={this._onExpect}>
              뽑기선택
            </button>
          </div>
        ) : (
          /*
                     <li>
                         <div className="item">
                            <div className="thumb"><a onClick={this._onExpect} style={{ cursor: 'pointer'}}><img src=""/>ANIPLUS {grade}</a></div>
                         </div>
                     </li>
                    */
          <div className="item">
            <div className="thumb">
              <a
                onClick={() => this._goContent(contentSerial)}
                style={{ cursor: 'pointer' }}
              >
                <img src={img} />
              </a>
            </div>
            <div className="info">
              <p className="date">
                <img
                  src={imgUrl + '/img/event/event220617/ico_live.png'}
                  alt="LIVE"
                />{' '}
                {comment}
              </p>
              <p className="subject">
                <a
                  onClick={() => this._goContent(contentSerial)}
                  style={{ cursor: 'pointer' }}
                >
                  {title}
                </a>
              </p>
            </div>
            <button
              type="button"
              className={alram === 0 ? 'btnAlram' : 'btnAlram active'}
            >
              뽑기선택
            </button>
          </div>
        )}
      </Fragment>
    );
  }
}

export default shopContext(withRouter(ContentItem5));
